import React  from "react";
import { useParams } from 'react-router-dom';
import BreedingEventForm from "./components/BreedingEventForm";

const ViewBreedingEvent = () => {
	const { breedingeventId } = useParams();
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<BreedingEventForm recordId={breedingeventId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewBreedingEvent;